<template>
  <div class="contracts-content">
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="care-created"
      title="NOVO CUIDADO"
    >
      <div class="row">
        <div class="col-md-12 pb-0 pt-0">
          <h6 class="upper-text">Período de validação da prescrição</h6>
        </div>

        <div class="col-md-12">
          <div class="col-xl-12 v-clean pt-0 pl-0 pr-0 pb-2">
            <h6 class="upper-text text-fourteen worksansr p-2 mb-0 text-center">
              <i
                class="fas fa-exclamation-circle color-warning text-twenty mr-1"
              ></i>
              FREQUÊNCIA
            </h6>
            <h6 class="upper-text pl-2 mb-0 text-center">
              <strong>DIÁRIO/SEMANAL/EVENTUAL</strong>
            </h6>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
          <label>DATA DE INÍCIO</label>
          <input v-model="start_date" type="date" class="form-control" />
        </div>

        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
          <label>DATA DE TÉRMINO</label>
          <input v-model="end_date" type="date" class="form-control" />
        </div>

        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
        </div>

        <div class="col-md-12 text-right">
          <v-btn :disabled="loading" @click="create" class="btn-save"
            ><i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}</v-btn
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "CareCreated",

  components: {
    ErrorsMessages,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      loading: false,

      start_date: "",

      end_date: "",

      errors: [],
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        let { resident_id, start_date, end_date } = this;

        let params = {
          resident_id,
          start_date,
          end_date,
        };

        const response = await api.post(
          "/rest-home/group-prescription-care",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.$emit("create");

          this.$bvModal.hide("care-created");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        
        console.log(error);
      }
    },
  },
};
</script>